<div class="table-container">
  <div class="data-card">
    @if(!showTable) {
      <div class="no-data-message">
        Request has no Versions
      </div>
    } @else {
      <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource" matSort>

          <!-- Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
            <td mat-cell *matCellDef="let row">{{row.type | objectdesc}}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let row">{{row.name}}</td>
          </ng-container>

          <!-- Notes Column -->
          <ng-container matColumnDef="notes">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Notes </th>
            <td mat-cell *matCellDef="let row">{{row.notes}}</td>
          </ng-container>

          <!-- Created Column -->
          <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Created </th>
            <td mat-cell *matCellDef="let row"> {{row.dateCreated | date:'d/M/yyyy'}} </td>
          </ng-container>

          <!-- TxId Column -->
          <ng-container matColumnDef="txId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> TxId </th>
            <td mat-cell *matCellDef="let row">
              <span matRipple [class.ref-code]="row.txId != null" [cdkCopyToClipboard]="row.txId" (click)="onCopyTxId(row.txId)">{{row.txId}}</span>
            </td>
          </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
          <td mat-cell *matCellDef="let row">
            <span class="badge" [ngClass]="{
              'badge-new': row.status.id == 80,
              'badge-pending': row.status.id == 2,
              'badge-processing': row.status.id == 81 || row.status.id == 63,
              'badge-rejected': row.status.id == 4 || row.status.id == 7,
              'badge-reload': row.status.id == 5,
              'badge-approved': row.status.id == 6 }">
              <span class="badge-dot"></span>
              {{row.status | objectdesc}}
            </span>
          </td>
        </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let row">
              <div class="actions">
                @if( allowUpdateVersion ) {
                  <button matButton class="act-btn" (click)="onEditVersion(row)" matTooltip="Edit Version">
                    <i class="fa-solid fa-pen"></i>
                  </button>
                }
                @if( allowDeleteVersion() ) {
                  <button matButton class="act-btn danger" (click)="onDeleteVersion(row)" matTooltip="Delete">
                    <i class="fa-regular fa-trash-can"></i>
                  </button>
                }
                <!-- <button matButton class="act-btn" (click)="onViewHistory(row)" matTooltip="View History">
                  <i class="fa-regular fa-message"></i>
                </button> -->
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    }
  </div>
</div>
